// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import { PaginationConst } from '../constants/AppConstant';

/**
 * @description Get release based on the request criteria
 * @param {String} productId
 * @returns {Promise}
 */
export async function createLead(releaseObj: Object = {}) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/home/leads`,
    data: releaseObj,
  }); return response;
}

export async function getLeads( 
  pageNumber: number = 0,
  pageSize: number = PaginationConst.PAGE_SIZE, 
  filterObj: any = {},
  sort: string = 'createdDate,desc'
) {
  // Build query parameters
  const params: any = {
    page: pageNumber,
    size: pageSize,
    sort: sort,
  };

  // Add filter parameters
  Object.keys(filterObj).forEach((key) => {
    const value = filterObj[key];
    if (value !== null && value !== undefined && value !== '') {
      params[key] = value;
    }
  });

  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/leads`,
    params: params,
  }); 
  return response;
}

export async function getLeadsById(leadId: string) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/leads/${leadId}`
  }); 
  return response;
}

export async function updateLeadStatus(
  leadId: string,
  payload: { status: string; amount: number; emiAmount: number; emiDate: number }
) {
  const response = await HttpClient.PATCH({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/leads/${leadId}`,
    data: payload,
  });
  return response;
}
